import { render, staticRenderFns } from "./Ad.vue?vue&type=template&id=385449f0&"
import script from "./Ad.vue?vue&type=script&lang=js&"
export * from "./Ad.vue?vue&type=script&lang=js&"
import style0 from "./Ad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports